<mat-sidenav-container [hasBackdrop]="pageDataService.sidenavBackdropVisible$ | async" 
                       [class.sidenav-open]="pageDataService.sidenavOpen$ | async"
                       [class.sidenav-collapsed]="pageDataService.isCollapsed$ | async">
  <mat-sidenav style="position: fixed;" 
               [opened]="pageDataService.sidenavOpen$ | async" 
               [class.collapsed]="pageDataService.isCollapsed$ | async" 
               (openedStart)="updateHeight()" 
               (closedStart)="pageDataService.closeSidenav()"
               mode="push" 
               [disableClose]="true" 
               [autoFocus]="false">
    <div class="nav">
      <div class="nav-top">
        <ng-container *ngFor="let sidenavLink of sidenavLinks">
          <a *ngIf="sidenavLink.link" [routerLink]="sidenavLink.link" class="nav-item" [class.active]="isLinkActive(sidenavLink.link)" routerLinkActive="active">
            <img *ngIf="sidenavLink.isImage && sidenavLink.imagePath" [src]="sidenavLink.imagePath" class="sidenav-icon" alt="">
            <mat-icon *ngIf="!sidenavLink.isImage || !sidenavLink.imagePath">{{sidenavLink.icon}}</mat-icon>
            <span>{{sidenavLink.label | async}}</span>
          </a>
          <mat-expansion-panel *ngIf="sidenavLink.subLinks" [expanded]="sidenavLink.expanded" (expandedChange)="sidenavLink.expanded = $event">
            <mat-expansion-panel-header (click)="onExpandPanelClick()" class="nav-item" [class.active]="isAnySublinkActive(sidenavLink)" collapsedHeight="2.5em" expandedHeight="3em">
              <img *ngIf="sidenavLink.isImage && sidenavLink.imagePath" [src]="sidenavLink.imagePath" class="sidenav-icon" alt="">
              <mat-icon *ngIf="!sidenavLink.isImage || !sidenavLink.imagePath">{{sidenavLink.icon}}</mat-icon>
              <span>{{sidenavLink.label | async}}</span>
            </mat-expansion-panel-header>
            <div class="nav-sublist">
              <a *ngFor="let subLink of sidenavLink.subLinks" [routerLink]="subLink.link" class="nav-item sub-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <mat-icon class="sub-icon">play_arrow</mat-icon>
                <span>{{subLink.label | async | uppercase}}</span>
              </a>
            </div>
          </mat-expansion-panel>
        </ng-container>
      </div>
      <div class="nav-bottom">
        <img *ngIf="!(pageDataService.isCollapsed$ | async)" class="WL-logo" src="assets/img/Magellan-logo.svg" style="width: 80%;" alt="Magellan" />
        <span (click)="toggleSidenav()" class="pointer toggle-button">
          <mat-icon *ngIf="!(pageDataService.isCollapsed$ | async)">keyboard_double_arrow_left</mat-icon>
          <mat-icon *ngIf="(pageDataService.isCollapsed$ | async)">keyboard_double_arrow_right</mat-icon>
        </span>
        <!-- <a [routerLink]="UrlConstants.ACCOUNT" class="nav-item nav-user" routerLinkActive="active">{{authService.user.First_Name}} {{authService.user.Last_Name}}</a>
        <a [routerLink]="UrlConstants.LOGIN" class="nav-item nav-logout" [matTooltip]="'sidebar.logOut' | translate"><mat-icon>exit_to_app</mat-icon></a> -->
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="content-wrapper" [style.min-height]="contentHeight + 'px'">
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
